import { Center, Stack, Text } from '@mantine/core';

export function InternalServerError() {
	return (
		<Center w={'100%'}>
			<Stack align={'center'}>
				<Text fw={500}>Whoops!</Text>
				<Text>An error occurred. Please contact MedEpos support.</Text>
				<Text>Reload the app to continue.</Text>
			</Stack>
		</Center>
	);
}
